import React from 'react';
import {
  ExpoImage,
  Icon,
  LoadingIndicator,
  Pressable,
  ScreenContainer,
  SimpleStyleFlatList,
  Surface,
  SwitchRow,
  TextInput,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import * as Linking from 'expo-linking';
import { Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as LeadFunlDefaultApi from '../apis/LeadFunlDefaultApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import * as CustomImports from '../custom-files/CustomImports';
import formatAccounting from '../global-functions/formatAccounting';
import formatPhoneNumber from '../global-functions/formatPhoneNumber';
import palettes from '../themes/palettes';
import * as Utils from '../utils';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import showAlertUtil from '../utils/showAlert';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { client: { age: 18, _state_details: { tax_rate: 28 } } };

const ReportScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const [FIA_Bonus, setFIA_Bonus] = React.useState(
    (props.route?.params?.client ?? defaultProps.client)?._case_details
      ?.FIA_bonus
  );
  const [FIA_Data, setFIA_Data] = React.useState([]);
  const [age, setAge] = React.useState(
    parseInt((props.route?.params?.client ?? defaultProps.client)?.age, 10)
  );
  const [amountToConvert, setAmountToConvert] = React.useState(
    (props.route?.params?.client ?? defaultProps.client)?._case_details?.amount
  );
  const [beginningBalance, setBeginningBalance] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [isPrinting, setIsPrinting] = React.useState(false);
  const [minusTaxes, setMinusTaxes] = React.useState(true);
  const [nameOfCustomer, setNameOfCustomer] = React.useState(
    (props.route?.params?.client ?? defaultProps.client)?.name
  );
  const [rateOfReturn, setRateOfReturn] = React.useState(
    (props.route?.params?.client ?? defaultProps.client)?._case_details
      ?.rate_of_return
  );
  const [rothYearsData, setRothYearsData] = React.useState([]);
  const [taxFreeRothFIAArray, setTaxFreeRothFIAArray] = React.useState([]);
  const [taxRate, setTaxRate] = React.useState(
    (props.route?.params?.client ?? defaultProps.client)?._case_details
      ?.tax_rate
  );
  const [textInput2Value, setTextInput2Value] = React.useState('');
  const [totalValueOfFia, setTotalValueOfFia] = React.useState([]);
  const [yearsToConvert, setYearsToConvert] = React.useState(
    (props.route?.params?.client ?? defaultProps.client)?._case_details
      ?.years_to_convert
  );
  const [switchValue, setSwitchValue] = React.useState(false);
  const [textInputValue, setTextInputValue] = React.useState('');
  const generateFIAData = () => {
    function calculatePMT(rate, nper, pv) {
      // const r = rate / 100; // Convert to decimal rate
      // let temp = Math.pow(1 + r, -nper)
      // return 136275.131
      // return Math.round((pv * r) / (1 - temp));
      // return Math.round((pv * r) / (1 - Math.pow(1 + r, -nper))); // PMT formula for annual payments
      let fv = 0;
      let type = 0;
      if (rate === 0) {
        return -(pv + fv) / nper;
      }

      const pvif = Math.pow(1 + rate, nper); // Present Value Interest Factor
      let pmtValue = (rate / (pvif - 1)) * -(pv * pvif + fv);

      if (type === 1) {
        pmtValue /= 1 + rate;
      }

      return pmtValue;
    }
    console.log('calulating years ', yearsToConvert);
    // Calculate the Conversion Amount (with a fixed expected result of 136275)
    //const conversionAmount = calculatePMT(.05, 10, 500000);
    const startingBalance =
      amountToConvert * (1 + FIA_Bonus / 100) * (1 + rateOfReturn / 100); // Math.round(amountToConvert * (1 + (FIA_Bonus / 100)) * (1 + (rateOfReturn / 100))); // Initial IRA_FIA_Balanc
    const beginingBalance = amountToConvert * (1 + FIA_Bonus / 100);

    const conversionAmount = Math.abs(
      calculatePMT(rateOfReturn / 100, yearsToConvert, beginingBalance)
    );

    let result = [];
    let startingAge = parseInt(age) + 1; // Initialize starting age
    let iraFiaBalance = startingBalance; // Initialize IRA_FIA_Balance
    let remainingIraFiaBalance;
    let taxesPaid;

    for (let i = 1; i <= yearsToConvert + 1; i++) {
      remainingIraFiaBalance = iraFiaBalance - conversionAmount;
      taxesPaid =
        remainingIraFiaBalance >= 0 ? conversionAmount * (taxRate / 100) : ''; //Math.round(conversionAmount * (taxRate / 100)) : '';

      result.push({
        year: i,
        age: startingAge++,
        iraFiaBalance: iraFiaBalance > 0 ? iraFiaBalance : '',
        conversionAmount: iraFiaBalance > 10 ? conversionAmount : '',
        remainingIraFiaBalance:
          remainingIraFiaBalance >= 0 ? remainingIraFiaBalance : '', // Math.round(remainingIraFiaBalance) : '',
        taxesPaid: taxesPaid || '',
        taxFreeValueOfRothFia: 0, // Placeholder value
        totalValueOfFia: 0, // Placeholder value
      });

      // Update IRA_FIA_Balance for the next year
      iraFiaBalance =
        remainingIraFiaBalance > 0
          ? remainingIraFiaBalance * (1 + rateOfReturn / 100)
          : 0;
    }

    let finalArr = [];
    for (let row = 0; row < yearsToConvert; row++) {
      let obj = [];

      for (let col = 0; col < result.length; col++) {
        if (col === 0) {
          if (minusTaxes === true) {
            obj.push(result[row].conversionAmount - result[row].taxesPaid);
          } else {
            obj.push(result[row].conversionAmount);
          }
        } else {
          obj.push(obj[col - 1] * (1 + rateOfReturn / 100));
        }
      }
      finalArr.push(obj);
    }
    for (let i = 1; i < finalArr.length; i++) {
      finalArr[i] = new Array(i)
        .fill(0)
        .concat(finalArr[i].slice(0, finalArr[i].length - i));
    }

    let taxFreeValueArr = [];
    for (let col = 0; col < finalArr[0].length; col++) {
      let acc = 0;
      for (let row = 0; row < finalArr.length; row++) {
        acc += finalArr[row][col];
      }

      taxFreeValueArr.push(acc);
    }

    return {
      fiaData: result,
      rothYearData: finalArr,
      taxFreeValueRothFIA: taxFreeValueArr,
      totalValueOfFia: taxFreeValueArr.map(
        (item, idx) => item + result[idx].remainingIraFiaBalance
      ),
    };
  };

  const invokeCapture = () => {
    onCapture();
  };
  const { captureRef, FileSystem, printToFileAsync } = CustomImports;

  React.useMemo(() => {
    if (
      !(
        amountToConvert &&
        rateOfReturn &&
        yearsToConvert &&
        age &&
        FIA_Bonus &&
        taxRate
      )
    ) {
      return;
    }
    setFIA_Data([]);
    setRothYearsData([]);
    setTaxFreeRothFIAArray([]);
    setTotalValueOfFia([]);
    try {
      console.log('in callback');
      if ((props.route?.params?.client ?? defaultProps.client)?.id) {
        setNameOfCustomer(
          (props.route?.params?.client ?? defaultProps.client)?.name
        );
        setAge(
          (() => {
            const e = (props.route?.params?.client ?? defaultProps.client)?.age;
            console.log(e);
            return e;
          })()
        );
      } else {
      }
      const resData = generateFIAData();
      console.log({ resData });
      const valueKznklGac = resData?.fiaData;
      const resFIA = valueKznklGac;
      setFIA_Data(valueKznklGac);
      setRothYearsData(resData?.rothYearData);
      setTaxFreeRothFIAArray(resData?.taxFreeValueRothFIA);
      setTotalValueOfFia(resData?.totalValueOfFia);
      console.log(rateOfReturn);
    } catch (err) {
      console.error(err);
    }
  }, [
    amountToConvert,
    rateOfReturn,
    yearsToConvert,
    age,
    FIA_Bonus,
    minusTaxes,
    taxRate,
  ]);

  const ref = React.useRef();

  const onCapture = React.useCallback(async () => {
    // ViewShot.Catpure
    const localUri = await captureRef(ref, {
      format: 'png',
      quality: 1,
    });
    const html = `
<html>
      <body style="padding: 12px">
        <img src="${localUri}" style="width: 100%; height: auto;" />
      </body>
</html>
`;

    const file = await printToFileAsync({
      html: html,
      base64: false,
    });
    setIsPrinting(false);
    console.log('saved file at: ', file);
  }, []);
  const leadFunlDefaultAddACasePOST = LeadFunlDefaultApi.useAddACasePOST();
  const isFocused = useIsFocused();
  React.useEffect(() => {
    try {
      if (!isFocused) {
        return;
      }
      console.log(Constants['AUTH_USER']);
    } catch (err) {
      console.error(err);
    }
  }, [isFocused]);

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        { backgroundColor: palettes.App.White },
        dimensions.width
      )}
    >
      {/* Header */}
      <>
        {isPrinting ? null : (
          <View
            style={StyleSheet.applyWidth(
              {
                alignItems: 'center',
                borderBottomWidth: 1,
                borderColor: palettes.Brand.Divider,
                flexDirection: 'row',
                height: 48,
                justifyContent: 'space-between',
              },
              dimensions.width
            )}
          >
            {/* Back */}
            <Pressable
              onLongPress={() => {
                try {
                  /* hidden 'Run a Custom Function' action */
                } catch (err) {
                  console.error(err);
                }
              }}
              onPress={() => {
                try {
                  navigation.navigate('DashboardScreen');
                } catch (err) {
                  console.error(err);
                }
              }}
              activeOpacity={0.3}
            >
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: 'center',
                    height: 48,
                    justifyContent: 'center',
                    width: 48,
                  },
                  dimensions.width
                )}
              >
                <Icon
                  size={24}
                  color={theme.colors.branding.primary}
                  name={'Ionicons/chevron-back'}
                />
              </View>
            </Pressable>

            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Tablet, value: 'center' },
                  flex: { minWidth: Breakpoints.Tablet, value: 1 },
                  flexDirection: { minWidth: Breakpoints.Tablet, value: 'row' },
                  justifyContent: {
                    minWidth: Breakpoints.Tablet,
                    value: 'center',
                  },
                },
                dimensions.width
              )}
            >
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: theme.colors.branding.primary,
                      fontFamily: [
                        {
                          minWidth: Breakpoints.Mobile,
                          value: 'Aclonica_400Regular',
                        },
                        {
                          minWidth: Breakpoints.Tablet,
                          value: 'Aclonica_400Regular',
                        },
                      ],
                      fontSize: 21,
                      textAlign: 'center',
                    }
                  ),
                  dimensions.width
                )}
              >
                {'ROTH Plan'}
              </Text>

              <View
                style={StyleSheet.applyWidth(
                  {
                    marginLeft: { minWidth: Breakpoints.Tablet, value: 20 },
                    marginRight: { minWidth: Breakpoints.Tablet, value: 20 },
                    width: { minWidth: Breakpoints.Tablet, value: 140 },
                  },
                  dimensions.width
                )}
              >
                <SwitchRow
                  onValueChange={newSwitchRowValue => {
                    const switchValue = newSwitchRowValue;
                    try {
                      setMinusTaxes(newSwitchRowValue);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  {...GlobalStyles.SwitchRowStyles(theme)['Switch Row'].props}
                  label={'Minus Taxes'}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.SwitchRowStyles(theme)['Switch Row'].style,
                      {
                        fontFamily: {
                          minWidth: Breakpoints.Tablet,
                          value: 'Poppins_400Regular',
                        },
                      }
                    ),
                    dimensions.width
                  )}
                  value={minusTaxes}
                />
              </View>
            </View>
            {/* PDF */}
            <Pressable
              onLongPress={() => {
                try {
                  invokeCapture();
                } catch (err) {
                  console.error(err);
                }
              }}
              onPress={() => {
                try {
                  setIsPrinting(true);
                  invokeCapture();
                } catch (err) {
                  console.error(err);
                }
              }}
              activeOpacity={0.3}
            >
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: 'center',
                    height: 48,
                    justifyContent: 'center',
                    width: 48,
                  },
                  dimensions.width
                )}
              >
                <Icon
                  size={24}
                  color={theme.colors.branding.primary}
                  name={'AntDesign/pdffile1'}
                />
              </View>
            </Pressable>
            {/* Save */}
            <Pressable
              onPress={() => {
                const handler = async () => {
                  try {
                    setIsLoading(true);
                    const res = (
                      await leadFunlDefaultAddACasePOST.mutateAsync({
                        FIA_bonus: FIA_Bonus,
                        amount: amountToConvert,
                        clients_id: (
                          props.route?.params?.client ?? defaultProps.client
                        )?.id,
                        rate_of_return: rateOfReturn,
                        tax_rate: taxRate,
                        years_to_convert: yearsToConvert,
                      })
                    )?.json;
                    setIsLoading(false);
                    if (res?.id) {
                      showAlertUtil({
                        title: 'Details Saved',
                        message: 'The details have been saved.',
                        buttonText: 'Okay',
                      });
                    }
                  } catch (err) {
                    console.error(err);
                  }
                };
                handler();
              }}
              activeOpacity={0.3}
            >
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: 'center',
                    height: 48,
                    justifyContent: 'center',
                    width: 48,
                  },
                  dimensions.width
                )}
              >
                <>
                  {isLoading ? null : (
                    <Icon
                      size={24}
                      color={theme.colors.branding.primary}
                      name={'Ionicons/save'}
                    />
                  )}
                </>
                <>
                  {!isLoading ? null : (
                    <LoadingIndicator
                      color={theme.colors.branding.primary}
                      size={30}
                      type={'circleFade'}
                      type={StyleSheet.getWidthValue(
                        [{ minWidth: Breakpoints.Tablet, value: 'grid' }],
                        dimensions.width
                      )}
                    />
                  )}
                </>
                <>
                  {isLoading ? null : (
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          theme.typography.body1,
                          {
                            fontSize: {
                              minWidth: Breakpoints.Tablet,
                              value: 8,
                            },
                            lineHeight: {
                              minWidth: Breakpoints.Tablet,
                              value: 8,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Save'}
                    </Text>
                  )}
                </>
              </View>
            </Pressable>
          </View>
        )}
      </>
      <Utils.CustomCodeErrorBoundary>
        <View ref={ref}>
          {/* Container */}
          <View>
            {/* Top View */}
            <Surface
              {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
              elevation={3}
              style={StyleSheet.applyWidth(
                StyleSheet.compose(
                  GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                  { paddingBottom: { minWidth: Breakpoints.Tablet, value: 10 } }
                ),
                dimensions.width
              )}
            >
              {/* Top View */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: {
                      minWidth: Breakpoints.Tablet,
                      value: 'stretch',
                    },
                    flexDirection: {
                      minWidth: Breakpoints.Tablet,
                      value: 'row',
                    },
                    justifyContent: {
                      minWidth: Breakpoints.Tablet,
                      value: 'space-between',
                    },
                  },
                  dimensions.width
                )}
              >
                {/* Inputs */}
                <Surface
                  elevation={0}
                  {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                      {
                        flex: { minWidth: Breakpoints.Tablet, value: 0.35 },
                        marginTop: [
                          { minWidth: Breakpoints.Mobile, value: 5 },
                          { minWidth: Breakpoints.Tablet, value: 0 },
                        ],
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {/* Header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        backgroundColor: theme.colors.branding.primary,
                        height: 30,
                        justifyContent: 'center',
                        marginBottom: {
                          minWidth: Breakpoints.Tablet,
                          value: 8,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          { color: palettes.App.White, fontSize: 16 }
                        ),
                        dimensions.width
                      )}
                    >
                      {'ROTH Conversion Plan'}
                    </Text>
                  </View>
                  {/* Customer */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        padding: 8,
                        paddingTop: { minWidth: Breakpoints.Tablet, value: 4 },
                      },
                      dimensions.width
                    )}
                  >
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                        .props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                            .style,
                          { flex: { minWidth: Breakpoints.Tablet, value: 1 } }
                        ),
                        dimensions.width
                      )}
                    >
                      <View>
                        <TextInput
                          autoCapitalize={'none'}
                          autoCorrect={true}
                          changeTextDelay={500}
                          onChangeText={newTextInputValue => {
                            try {
                              setNameOfCustomer(newTextInputValue);
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          webShowOutline={true}
                          {...GlobalStyles.TextInputStyles(theme)['Text Input']
                            .props}
                          editable={false}
                          placeholder={'Name'}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.TextInputStyles(theme)['Text Input']
                                .style,
                              {
                                textTransform: {
                                  minWidth: Breakpoints.Tablet,
                                  value: 'capitalize',
                                },
                              }
                            ),
                            dimensions.width
                          )}
                          value={nameOfCustomer}
                        />
                      </View>
                    </Surface>
                    {/* Age */}
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                        .props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                            .style,
                          {
                            width: { minWidth: Breakpoints.Tablet, value: 120 },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      <View>
                        <TextInput
                          autoCapitalize={'none'}
                          autoCorrect={true}
                          changeTextDelay={500}
                          onChangeText={newTextInputValue => {
                            const textInputValue = newTextInputValue;
                            try {
                              setAge(parseInt(newTextInputValue, 10));
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          webShowOutline={true}
                          {...GlobalStyles.TextInputStyles(theme)['Text Input']
                            .props}
                          placeholder={'Age'}
                          placeholderTextColor={theme.colors.text.light}
                          style={StyleSheet.applyWidth(
                            GlobalStyles.TextInputStyles(theme)['Text Input']
                              .style,
                            dimensions.width
                          )}
                          value={age}
                        />
                      </View>
                    </Surface>
                  </View>
                  {/* Amount to ROTH Convert */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: [
                          {
                            minWidth: Breakpoints.Mobile,
                            value: 'space-between',
                          },
                          { minWidth: Breakpoints.Tablet, value: 'flex-end' },
                        ],
                        padding: 8,
                        paddingTop: { minWidth: Breakpoints.Tablet, value: 0 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        dimensions.width
                      )}
                    >
                      {'Amount to ROTH Convert: '}
                    </Text>
                    {/* Surface 2 */}
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                        .props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                            .style,
                          {
                            alignItems: {
                              minWidth: Breakpoints.Tablet,
                              value: 'center',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Tablet,
                              value: 'row',
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              color: {
                                minWidth: Breakpoints.Tablet,
                                value: amountToConvert?.length
                                  ? theme.colors.text.strong
                                  : theme.colors.text.light,
                              },
                              paddingLeft: {
                                minWidth: Breakpoints.Tablet,
                                value: 12,
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {'$'}
                      </Text>

                      <View
                        style={StyleSheet.applyWidth(
                          { flex: { minWidth: Breakpoints.Tablet, value: 1 } },
                          dimensions.width
                        )}
                      >
                        <TextInput
                          autoCapitalize={'none'}
                          autoCorrect={true}
                          changeTextDelay={500}
                          onChangeText={newTextInputValue => {
                            try {
                              if (newTextInputValue?.length < 1) {
                                setAmountToConvert(parseInt(0, 10));
                                setBeginningBalance(parseInt(0, 10));
                              } else {
                                setAmountToConvert(
                                  parseInt(newTextInputValue, 10)
                                );
                                setBeginningBalance(
                                  parseInt(newTextInputValue, 10) *
                                    (parseInt(FIA_Bonus, 10) / 100) +
                                    parseInt(newTextInputValue, 10)
                                );
                              }
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          webShowOutline={true}
                          {...GlobalStyles.TextInputStyles(theme)['Text Input']
                            .props}
                          placeholder={'Amount'}
                          placeholderTextColor={theme.colors.text.light}
                          style={StyleSheet.applyWidth(
                            GlobalStyles.TextInputStyles(theme)['Text Input']
                              .style,
                            dimensions.width
                          )}
                          value={amountToConvert}
                        />
                      </View>
                    </Surface>
                  </View>
                  {/* State - Tax Rate */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: [
                          {
                            minWidth: Breakpoints.Mobile,
                            value: 'space-between',
                          },
                          { minWidth: Breakpoints.Tablet, value: 'flex-end' },
                        ],
                        padding: 8,
                        paddingTop: { minWidth: Breakpoints.Tablet, value: 0 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        dimensions.width
                      )}
                    >
                      {'Tax Rate: '}
                    </Text>
                    {/* Input */}
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                        .props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                            .style,
                          {
                            alignItems: {
                              minWidth: Breakpoints.Tablet,
                              value: 'center',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Tablet,
                              value: 'row',
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          { flex: { minWidth: Breakpoints.Tablet, value: 1 } },
                          dimensions.width
                        )}
                      >
                        <TextInput
                          autoCapitalize={'none'}
                          autoCorrect={true}
                          changeTextDelay={500}
                          onChangeText={newTextInputValue => {
                            try {
                              if (newTextInputValue) {
                                setTaxRate(parseInt(newTextInputValue, 10));
                              } else {
                                setTaxRate(0);
                              }
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          webShowOutline={true}
                          {...GlobalStyles.TextInputStyles(theme)['Text Input']
                            .props}
                          placeholder={'Tax rate'}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.TextInputStyles(theme)['Text Input']
                                .style,
                              theme.typography.body2,
                              {}
                            ),
                            dimensions.width
                          )}
                          value={taxRate}
                        />
                      </View>

                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              color: {
                                minWidth: Breakpoints.Tablet,
                                value: rateOfReturn?.length
                                  ? theme.colors.text.strong
                                  : theme.colors.text.light,
                              },
                              paddingRight: {
                                minWidth: Breakpoints.Tablet,
                                value: 12,
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {'%'}
                      </Text>
                    </Surface>
                  </View>
                  {/* Rate of Return */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: [
                          {
                            minWidth: Breakpoints.Mobile,
                            value: 'space-between',
                          },
                          { minWidth: Breakpoints.Tablet, value: 'flex-end' },
                        ],
                        padding: 8,
                        paddingTop: { minWidth: Breakpoints.Tablet, value: 0 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        dimensions.width
                      )}
                    >
                      {'Rate of Return: '}
                    </Text>
                    {/* Input */}
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                        .props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                            .style,
                          {
                            alignItems: {
                              minWidth: Breakpoints.Tablet,
                              value: 'center',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Tablet,
                              value: 'row',
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          { flex: { minWidth: Breakpoints.Tablet, value: 1 } },
                          dimensions.width
                        )}
                      >
                        <TextInput
                          autoCapitalize={'none'}
                          autoCorrect={true}
                          changeTextDelay={500}
                          onChangeText={newTextInputValue => {
                            try {
                              if (newTextInputValue?.length) {
                                setRateOfReturn(
                                  parseInt(newTextInputValue, 10)
                                );
                              } else {
                                setRateOfReturn(0);
                              }
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          webShowOutline={true}
                          {...GlobalStyles.TextInputStyles(theme)['Text Input']
                            .props}
                          keyboardType={'numeric'}
                          placeholder={'Rate of return'}
                          placeholderTextColor={theme.colors.text.light}
                          style={StyleSheet.applyWidth(
                            GlobalStyles.TextInputStyles(theme)['Text Input']
                              .style,
                            dimensions.width
                          )}
                          value={rateOfReturn}
                        />
                      </View>

                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              color: {
                                minWidth: Breakpoints.Tablet,
                                value: rateOfReturn?.length
                                  ? theme.colors.text.strong
                                  : theme.colors.text.light,
                              },
                              paddingRight: {
                                minWidth: Breakpoints.Tablet,
                                value: 12,
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {'%'}
                      </Text>
                    </Surface>
                  </View>
                  {/* FIA Bonus */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: [
                          {
                            minWidth: Breakpoints.Mobile,
                            value: 'space-between',
                          },
                          { minWidth: Breakpoints.Tablet, value: 'flex-end' },
                        ],
                        padding: 8,
                        paddingTop: { minWidth: Breakpoints.Tablet, value: 0 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        dimensions.width
                      )}
                    >
                      {'[ '}
                      {
                        (props.route?.params?.client ?? defaultProps.client)
                          ?._state_details?.short_code
                      }
                      {' ] - FIA Bonus: '}
                    </Text>
                    {/* Surface 2 */}
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                        .props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                            .style,
                          {
                            alignItems: {
                              minWidth: Breakpoints.Tablet,
                              value: 'center',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Tablet,
                              value: 'row',
                            },
                            justifyContent: {
                              minWidth: Breakpoints.Tablet,
                              value: 'space-between',
                            },
                            width: 100,
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            width: [
                              { minWidth: Breakpoints.Mobile, value: 160 },
                              { minWidth: Breakpoints.Tablet, value: 160 },
                            ],
                          },
                          dimensions.width
                        )}
                      >
                        <TextInput
                          autoCapitalize={'none'}
                          autoCorrect={true}
                          changeTextDelay={500}
                          onChangeText={newTextInputValue => {
                            try {
                              if (newTextInputValue?.length) {
                                setFIA_Bonus(parseInt(newTextInputValue, 10));
                              } else {
                                setFIA_Bonus(0);
                              }
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          webShowOutline={true}
                          {...GlobalStyles.TextInputStyles(theme)['Text Input']
                            .props}
                          keyboardType={'numeric'}
                          placeholder={'FIA Bonus'}
                          placeholderTextColor={theme.colors.text.light}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.TextInputStyles(theme)['Text Input']
                                .style,
                              { width: 160 }
                            ),
                            dimensions.width
                          )}
                          value={FIA_Bonus}
                        />
                      </View>

                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              color: {
                                minWidth: Breakpoints.Tablet,
                                value: FIA_Bonus?.length
                                  ? theme.colors.text.strong
                                  : theme.colors.text.light,
                              },
                              paddingRight: {
                                minWidth: Breakpoints.Tablet,
                                value: 12,
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {'%'}
                      </Text>
                    </Surface>
                  </View>
                  {/* Years to Convert */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: [
                          {
                            minWidth: Breakpoints.Mobile,
                            value: 'space-between',
                          },
                          { minWidth: Breakpoints.Tablet, value: 'flex-end' },
                        ],
                        padding: 8,
                        paddingTop: { minWidth: Breakpoints.Tablet, value: 0 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        dimensions.width
                      )}
                    >
                      {'Years to Convert: '}
                    </Text>
                    {/* Surface 2 */}
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                        .props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                            .style,
                          {
                            alignItems: {
                              minWidth: Breakpoints.Tablet,
                              value: 'center',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Tablet,
                              value: 'row',
                            },
                            justifyContent: {
                              minWidth: Breakpoints.Tablet,
                              value: 'space-between',
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            width: { minWidth: Breakpoints.Tablet, value: 160 },
                          },
                          dimensions.width
                        )}
                      >
                        <TextInput
                          autoCapitalize={'none'}
                          autoCorrect={true}
                          changeTextDelay={500}
                          onChangeText={newTextInputValue => {
                            try {
                              if (newTextInputValue?.length) {
                                setYearsToConvert(
                                  parseInt(newTextInputValue, 10)
                                );
                              } else {
                                setYearsToConvert(0);
                              }
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                          webShowOutline={true}
                          {...GlobalStyles.TextInputStyles(theme)['Text Input']
                            .props}
                          keyboardType={'numeric'}
                          placeholder={'Years to Convert'}
                          style={StyleSheet.applyWidth(
                            GlobalStyles.TextInputStyles(theme)['Text Input']
                              .style,
                            dimensions.width
                          )}
                          value={yearsToConvert}
                        />
                      </View>

                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              color: {
                                minWidth: Breakpoints.Tablet,
                                value: yearsToConvert?.length
                                  ? theme.colors.text.strong
                                  : theme.colors.text.light,
                              },
                              paddingRight: {
                                minWidth: Breakpoints.Tablet,
                                value: 12,
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {'Yrs'}
                      </Text>
                    </Surface>
                  </View>
                  {/* Beginning Balance */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: [
                          {
                            minWidth: Breakpoints.Mobile,
                            value: 'space-between',
                          },
                          { minWidth: Breakpoints.Tablet, value: 'flex-end' },
                        ],
                        padding: 8,
                        paddingTop: { minWidth: Breakpoints.Tablet, value: 0 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        dimensions.width
                      )}
                    >
                      {'Beginning Balance: '}
                    </Text>
                    {/* Surface 2 */}
                    <Surface
                      {...GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                        .props}
                      elevation={3}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.SurfaceStyles(theme)['Input_Surface']
                            .style,
                          {
                            alignItems: {
                              minWidth: Breakpoints.Tablet,
                              value: 'center',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Tablet,
                              value: 'row',
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              color: {
                                minWidth: Breakpoints.Tablet,
                                value: beginningBalance?.length
                                  ? theme.colors.text.strong
                                  : theme.colors.text.light,
                              },
                              paddingLeft: {
                                minWidth: Breakpoints.Tablet,
                                value: 12,
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {'$'}
                      </Text>
                      {/* Text 2 */}
                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              paddingLeft: {
                                minWidth: Breakpoints.Tablet,
                                value: 12,
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {Math.ceil(amountToConvert * (FIA_Bonus / 100 + 1))}
                      </Text>
                    </Surface>
                  </View>
                </Surface>

                <View
                  style={StyleSheet.applyWidth(
                    {
                      borderBottomWidth: {
                        minWidth: Breakpoints.Tablet,
                        value: 0,
                      },
                      borderWidth: { minWidth: Breakpoints.Tablet, value: 1 },
                      flex: { minWidth: Breakpoints.Tablet, value: 0.4 },
                      padding: { minWidth: Breakpoints.Tablet, value: 8 },
                    },
                    dimensions.width
                  )}
                >
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Text'].props}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        {
                          fontFamily: {
                            minWidth: Breakpoints.Tablet,
                            value: 'Poppins_600SemiBold',
                          },
                          fontSize: { minWidth: Breakpoints.Tablet, value: 14 },
                          textAlign: {
                            minWidth: Breakpoints.Tablet,
                            value: 'center',
                          },
                        }
                      ),
                      dimensions.width
                    )}
                  >
                    {
                      'Pay Tax on the Seed versus Paying Tax on the Harvest…Forever'
                    }
                  </Text>
                  {/* Text 2 */}
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Text'].props}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        {
                          fontSize: { minWidth: Breakpoints.Tablet, value: 13 },
                          textAlign: {
                            minWidth: Breakpoints.Tablet,
                            value: 'center',
                          },
                        }
                      ),
                      dimensions.width
                    )}
                  >
                    {
                      'If you have a significant balance in your traditional IRA, you may want to carry out multiple ROTH IRA conversions over several years. We call this a "Partial ROTH Conversion Plan". If done properly, a multiyear approach could allow you to convert a large portion of your qualified funds while limiting you tax impact.  The result will be a completely Tax-Free asset that may then be turned in LIFETIME Tax-Free Income and/or passed to your estate.  The figures in this diagram are meant to be shown as an all-inclusive theoretical example.'
                    }
                  </Text>
                </View>
                {/* Agent */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: 'stretch',
                      flex: { minWidth: Breakpoints.Tablet, value: 0.25 },
                    },
                    dimensions.width
                  )}
                >
                  {/* Name */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        backgroundColor: theme.colors.branding.primary,
                        height: 30,
                        justifyContent: 'center',
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          { color: palettes.App.White, fontSize: 16 }
                        ),
                        dimensions.width
                      )}
                    >
                      {Constants['AUTH_USER']?.name}
                      {' - ['}
                      {Constants['AUTH_USER']?.designation}
                      {']'}
                    </Text>
                  </View>
                  {/* Details */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        flex: { minWidth: Breakpoints.Tablet, value: 1 },
                        flexDirection: [
                          { minWidth: Breakpoints.Mobile, value: 'row' },
                          { minWidth: Breakpoints.Tablet, value: 'column' },
                        ],
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        width: { minWidth: Breakpoints.Tablet, value: '100%' },
                      },
                      dimensions.width
                    )}
                  >
                    {/* Logo */}
                    <ExpoImage
                      allowDownscaling={true}
                      cachePolicy={'disk'}
                      contentPosition={'center'}
                      transitionDuration={300}
                      transitionEffect={'cross-dissolve'}
                      transitionTiming={'ease-in-out'}
                      {...GlobalStyles.ExpoImageStyles(theme)['Image 4'].props}
                      resizeMode={'contain'}
                      source={imageSource(
                        `${Constants['AUTH_USER']?._agency_details?.logo?.url}`
                      )}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.ExpoImageStyles(theme)['Image 4'].style,
                          {
                            height: [
                              { minWidth: Breakpoints.Mobile, value: 80 },
                              { minWidth: Breakpoints.Tablet, value: 120 },
                            ],
                            width: {
                              minWidth: Breakpoints.Tablet,
                              value: '100%',
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    />
                    {/* Contact details */}
                    <View
                      style={StyleSheet.applyWidth(
                        {
                          justifyContent: 'center',
                          marginTop: {
                            minWidth: Breakpoints.Tablet,
                            value: 20,
                          },
                          padding: 8,
                        },
                        dimensions.width
                      )}
                    >
                      {/* phone */}
                      <Pressable
                        onPress={() => {
                          try {
                            Linking.openURL(
                              `tel:${Constants['AUTH_USER']?.phone}`
                            );
                          } catch (err) {
                            console.error(err);
                          }
                        }}
                        activeOpacity={0.3}
                      >
                        {/* phone */}
                        <Text
                          accessible={true}
                          selectable={false}
                          {...GlobalStyles.TextStyles(theme)['Text'].props}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.TextStyles(theme)['Text'].style,
                              { textAlign: 'center' }
                            ),
                            dimensions.width
                          )}
                        >
                          {formatPhoneNumber(Constants['AUTH_USER']?.phone)}
                        </Text>
                      </Pressable>
                      {/* email */}
                      <Pressable
                        onPress={() => {
                          try {
                            Linking.openURL(
                              `mailto:${Constants['AUTH_USER']?.email}`
                            );
                          } catch (err) {
                            console.error(err);
                          }
                        }}
                        activeOpacity={0.3}
                        style={StyleSheet.applyWidth(
                          { marginTop: 5 },
                          dimensions.width
                        )}
                      >
                        {/* email */}
                        <Text
                          accessible={true}
                          selectable={false}
                          {...GlobalStyles.TextStyles(theme)['Text'].props}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.TextStyles(theme)['Text'].style,
                              {
                                color: theme.colors.branding.primary,
                                textAlign: 'center',
                              }
                            ),
                            dimensions.width
                          )}
                        >
                          {Constants['AUTH_USER']?.email}
                        </Text>
                      </Pressable>
                    </View>
                  </View>
                </View>
              </View>
            </Surface>
            {/* Report */}
            <Surface
              {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
              elevation={3}
              style={StyleSheet.applyWidth(
                StyleSheet.compose(
                  GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                  { marginTop: { minWidth: Breakpoints.Tablet, value: 1 } }
                ),
                dimensions.width
              )}
            >
              {/* Report */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    flexDirection: {
                      minWidth: Breakpoints.Tablet,
                      value: 'row',
                    },
                  },
                  dimensions.width
                )}
              >
                {/* Contract Year */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Tablet,
                        value: 'stretch',
                      },
                      maxWidth: { minWidth: Breakpoints.Tablet, value: 65 },
                    },
                    dimensions.width
                  )}
                >
                  {/* header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Tablet,
                          value: palettes.Brand.Divider,
                        },
                        height: { minWidth: Breakpoints.Tablet, value: 52 },
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['table_headers'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['table_headers'].style,
                        dimensions.width
                      )}
                    >
                      {'Contract \nYear'}
                    </Text>
                  </View>
                  <SimpleStyleFlatList
                    data={FIA_Data}
                    decelerationRate={'normal'}
                    horizontal={false}
                    inverted={false}
                    keyExtractor={(listData, index) => index}
                    keyboardShouldPersistTaps={'never'}
                    listKey={
                      'Custom Code->Container->Report->Report->Contract Year->List'
                    }
                    nestedScrollEnabled={false}
                    numColumns={1}
                    onEndReachedThreshold={0.5}
                    pagingEnabled={false}
                    renderItem={({ item, index }) => {
                      const listData = item;
                      return (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              borderWidth: {
                                minWidth: Breakpoints.Tablet,
                                value: 1,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: Constants['ROW_HEIGHT'],
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['table_values']
                              .props}
                            style={StyleSheet.applyWidth(
                              GlobalStyles.TextStyles(theme)['table_values']
                                .style,
                              dimensions.width
                            )}
                          >
                            {listData?.year}
                          </Text>
                        </View>
                      );
                    }}
                    showsHorizontalScrollIndicator={true}
                    showsVerticalScrollIndicator={true}
                    snapToAlignment={'start'}
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'stretch',
                        },
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* Age */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Tablet,
                        value: 'stretch',
                      },
                      width: { minWidth: Breakpoints.Tablet, value: 55 },
                    },
                    dimensions.width
                  )}
                >
                  {/* header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Tablet,
                          value: palettes.Brand.Divider,
                        },
                        height: { minWidth: Breakpoints.Tablet, value: 52 },
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['table_headers'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['table_headers'].style,
                          {
                            fontSize: {
                              minWidth: Breakpoints.Tablet,
                              value: 11,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Age'}
                    </Text>
                  </View>
                  <SimpleStyleFlatList
                    data={FIA_Data}
                    decelerationRate={'normal'}
                    horizontal={false}
                    inverted={false}
                    keyExtractor={(listData, index) =>
                      listData?.id ??
                      listData?.uuid ??
                      index?.toString() ??
                      JSON.stringify(listData)
                    }
                    keyboardShouldPersistTaps={'never'}
                    listKey={
                      'Custom Code->Container->Report->Report->Age->List'
                    }
                    nestedScrollEnabled={false}
                    numColumns={1}
                    onEndReachedThreshold={0.5}
                    pagingEnabled={false}
                    renderItem={({ item, index }) => {
                      const listData = item;
                      return (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              borderWidth: {
                                minWidth: Breakpoints.Tablet,
                                value: 1,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: Constants['ROW_HEIGHT'],
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['table_values']
                              .props}
                            style={StyleSheet.applyWidth(
                              GlobalStyles.TextStyles(theme)['table_values']
                                .style,
                              dimensions.width
                            )}
                          >
                            {listData?.age}
                          </Text>
                        </View>
                      );
                    }}
                    showsHorizontalScrollIndicator={true}
                    showsVerticalScrollIndicator={true}
                    snapToAlignment={'start'}
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'stretch',
                        },
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* IRA FIA Balance */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Tablet,
                        value: 'stretch',
                      },
                      width: { minWidth: Breakpoints.Tablet, value: 75 },
                    },
                    dimensions.width
                  )}
                >
                  {/* header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Tablet,
                          value: palettes.Brand.Divider,
                        },
                        height: { minWidth: Breakpoints.Tablet, value: 52 },
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['table_headers'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['table_headers'].style,
                        dimensions.width
                      )}
                    >
                      {'IRA FIA Balance'}
                    </Text>
                  </View>
                  <SimpleStyleFlatList
                    data={FIA_Data}
                    decelerationRate={'normal'}
                    horizontal={false}
                    inverted={false}
                    keyExtractor={(listData, index) =>
                      listData?.id ??
                      listData?.uuid ??
                      index?.toString() ??
                      JSON.stringify(listData)
                    }
                    keyboardShouldPersistTaps={'never'}
                    listKey={
                      'Custom Code->Container->Report->Report->IRA FIA Balance->List'
                    }
                    nestedScrollEnabled={false}
                    numColumns={1}
                    onEndReachedThreshold={0.5}
                    pagingEnabled={false}
                    renderItem={({ item, index }) => {
                      const listData = item;
                      return (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              borderWidth: {
                                minWidth: Breakpoints.Tablet,
                                value: 1,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: Constants['ROW_HEIGHT'],
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['table_values']
                              .props}
                            style={StyleSheet.applyWidth(
                              StyleSheet.compose(
                                GlobalStyles.TextStyles(theme)['table_values']
                                  .style,
                                {
                                  fontSize: {
                                    minWidth: Breakpoints.Tablet,
                                    value: 11,
                                  },
                                }
                              ),
                              dimensions.width
                            )}
                          >
                            {formatAccounting(listData?.iraFiaBalance)}
                          </Text>
                        </View>
                      );
                    }}
                    showsHorizontalScrollIndicator={true}
                    showsVerticalScrollIndicator={true}
                    snapToAlignment={'start'}
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'stretch',
                        },
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* Conversion Amount */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Tablet,
                        value: 'stretch',
                      },
                      width: { minWidth: Breakpoints.Tablet, value: 75 },
                    },
                    dimensions.width
                  )}
                >
                  {/* header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Tablet,
                          value: palettes.Brand.Divider,
                        },
                        height: { minWidth: Breakpoints.Tablet, value: 52 },
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        paddingLeft: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['table_headers'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['table_headers'].style,
                        dimensions.width
                      )}
                    >
                      {'Conversion \nAmount'}
                    </Text>
                  </View>
                  <SimpleStyleFlatList
                    data={FIA_Data}
                    decelerationRate={'normal'}
                    horizontal={false}
                    inverted={false}
                    keyExtractor={(listData, index) =>
                      listData?.id ??
                      listData?.uuid ??
                      index?.toString() ??
                      JSON.stringify(listData)
                    }
                    keyboardShouldPersistTaps={'never'}
                    listKey={
                      'Custom Code->Container->Report->Report->Conversion Amount->List'
                    }
                    nestedScrollEnabled={false}
                    numColumns={1}
                    onEndReachedThreshold={0.5}
                    pagingEnabled={false}
                    renderItem={({ item, index }) => {
                      const listData = item;
                      return (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              borderWidth: {
                                minWidth: Breakpoints.Tablet,
                                value: 1,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: Constants['ROW_HEIGHT'],
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <>
                            {!(listData?.conversionAmount > 0) ? null : (
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'table_values'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'table_values'
                                    ].style,
                                    {
                                      fontSize: {
                                        minWidth: Breakpoints.Tablet,
                                        value: 11,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {formatAccounting(listData?.conversionAmount)}
                              </Text>
                            )}
                          </>
                        </View>
                      );
                    }}
                    showsHorizontalScrollIndicator={true}
                    showsVerticalScrollIndicator={true}
                    snapToAlignment={'start'}
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'stretch',
                        },
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* Remaining IRA FIA Balance */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Tablet,
                        value: 'stretch',
                      },
                      width: { minWidth: Breakpoints.Tablet, value: 80 },
                    },
                    dimensions.width
                  )}
                >
                  {/* header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Tablet,
                          value: palettes.Brand.Divider,
                        },
                        height: { minWidth: Breakpoints.Tablet, value: 52 },
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        paddingLeft: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['table_headers'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['table_headers'].style,
                        dimensions.width
                      )}
                    >
                      {'Remaining \nIRA FIA Balance'}
                    </Text>
                  </View>
                  <SimpleStyleFlatList
                    data={FIA_Data}
                    decelerationRate={'normal'}
                    horizontal={false}
                    inverted={false}
                    keyExtractor={(listData, index) =>
                      listData?.id ??
                      listData?.uuid ??
                      index?.toString() ??
                      JSON.stringify(listData)
                    }
                    keyboardShouldPersistTaps={'never'}
                    listKey={
                      'Custom Code->Container->Report->Report->Remaining IRA FIA Balance->List'
                    }
                    nestedScrollEnabled={false}
                    numColumns={1}
                    onEndReachedThreshold={0.5}
                    pagingEnabled={false}
                    renderItem={({ item, index }) => {
                      const listData = item;
                      return (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              borderWidth: {
                                minWidth: Breakpoints.Tablet,
                                value: 1,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: Constants['ROW_HEIGHT'],
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <>
                            {!(listData?.remainingIraFiaBalance > 0) ? null : (
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'table_values'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'table_values'
                                    ].style,
                                    {
                                      fontSize: {
                                        minWidth: Breakpoints.Tablet,
                                        value: 11,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {formatAccounting(
                                  listData?.remainingIraFiaBalance
                                )}
                              </Text>
                            )}
                          </>
                        </View>
                      );
                    }}
                    showsHorizontalScrollIndicator={true}
                    showsVerticalScrollIndicator={true}
                    snapToAlignment={'start'}
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'stretch',
                        },
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* Taxes Paid  */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Tablet,
                        value: 'stretch',
                      },
                      width: { minWidth: Breakpoints.Tablet, value: 60 },
                    },
                    dimensions.width
                  )}
                >
                  {/* header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Tablet,
                          value: palettes.Brand.Divider,
                        },
                        height: { minWidth: Breakpoints.Tablet, value: 52 },
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        paddingLeft: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['table_headers'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['table_headers'].style,
                          {
                            fontSize: {
                              minWidth: Breakpoints.Tablet,
                              value: 11,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Taxes Paid '}
                    </Text>
                  </View>
                  <SimpleStyleFlatList
                    data={FIA_Data}
                    decelerationRate={'normal'}
                    horizontal={false}
                    inverted={false}
                    keyExtractor={(listData, index) =>
                      listData?.id ??
                      listData?.uuid ??
                      index?.toString() ??
                      JSON.stringify(listData)
                    }
                    keyboardShouldPersistTaps={'never'}
                    listKey={
                      'Custom Code->Container->Report->Report->Taxes Paid ->List'
                    }
                    nestedScrollEnabled={false}
                    numColumns={1}
                    onEndReachedThreshold={0.5}
                    pagingEnabled={false}
                    renderItem={({ item, index }) => {
                      const listData = item;
                      return (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              borderWidth: {
                                minWidth: Breakpoints.Tablet,
                                value: 1,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: Constants['ROW_HEIGHT'],
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <>
                            {!(listData?.taxesPaid > 0) ? null : (
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'table_values'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'table_values'
                                    ].style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Tablet,
                                        value: palettes.Brand.Error,
                                      },
                                      fontSize: {
                                        minWidth: Breakpoints.Tablet,
                                        value: 11,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {formatAccounting(listData?.taxesPaid)}
                              </Text>
                            )}
                          </>
                        </View>
                      );
                    }}
                    showsHorizontalScrollIndicator={true}
                    showsVerticalScrollIndicator={true}
                    snapToAlignment={'start'}
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'stretch',
                        },
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* Tax-Free Value of ROTH FIA */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Tablet,
                        value: 'stretch',
                      },
                      backgroundColor: {
                        minWidth: Breakpoints.Tablet,
                        value: palettes.App['Green BG'],
                      },
                      flex: { minWidth: Breakpoints.Tablet, value: 1 },
                      minWidth: { minWidth: Breakpoints.Tablet, value: 80 },
                    },
                    dimensions.width
                  )}
                >
                  {/* header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        height: { minWidth: Breakpoints.Tablet, value: 52 },
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        paddingLeft: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['table_headers'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['table_headers'].style,
                        dimensions.width
                      )}
                    >
                      {'Tax-Free Value \nof ROTH FIA'}
                    </Text>
                  </View>
                  <SimpleStyleFlatList
                    data={taxFreeRothFIAArray}
                    decelerationRate={'normal'}
                    horizontal={false}
                    inverted={false}
                    keyExtractor={(listData, index) =>
                      listData?.id ??
                      listData?.uuid ??
                      index?.toString() ??
                      JSON.stringify(listData)
                    }
                    keyboardShouldPersistTaps={'never'}
                    listKey={
                      'Custom Code->Container->Report->Report->Tax-Free Value of ROTH FIA->List'
                    }
                    nestedScrollEnabled={false}
                    numColumns={1}
                    onEndReachedThreshold={0.5}
                    pagingEnabled={false}
                    renderItem={({ item, index }) => {
                      const listData = item;
                      return (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              borderWidth: {
                                minWidth: Breakpoints.Tablet,
                                value: 1,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: Constants['ROW_HEIGHT'],
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['table_values']
                              .props}
                            style={StyleSheet.applyWidth(
                              GlobalStyles.TextStyles(theme)['table_values']
                                .style,
                              dimensions.width
                            )}
                          >
                            {formatAccounting(listData)}
                          </Text>
                        </View>
                      );
                    }}
                    showsHorizontalScrollIndicator={true}
                    showsVerticalScrollIndicator={true}
                    snapToAlignment={'start'}
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'stretch',
                        },
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* Total Value of FIA */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Tablet,
                        value: 'stretch',
                      },
                      backgroundColor: {
                        minWidth: Breakpoints.Tablet,
                        value: palettes.App['Custom Color 2'],
                      },
                      flex: { minWidth: Breakpoints.Tablet, value: 1 },
                      minWidth: { minWidth: Breakpoints.Tablet, value: 80 },
                    },
                    dimensions.width
                  )}
                >
                  {/* header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Tablet,
                          value: palettes.Brand.Divider,
                        },
                        height: { minWidth: Breakpoints.Tablet, value: 52 },
                        justifyContent: {
                          minWidth: Breakpoints.Tablet,
                          value: 'center',
                        },
                        paddingLeft: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Tablet,
                          value: 10,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['table_headers'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['table_headers'].style,
                        dimensions.width
                      )}
                    >
                      {'Total Value of \nFIA'}
                    </Text>
                  </View>
                  <SimpleStyleFlatList
                    data={totalValueOfFia}
                    decelerationRate={'normal'}
                    horizontal={false}
                    inverted={false}
                    keyExtractor={(listData, index) => listData}
                    keyboardShouldPersistTaps={'never'}
                    listKey={
                      'Custom Code->Container->Report->Report->Total Value of FIA->List'
                    }
                    nestedScrollEnabled={false}
                    numColumns={1}
                    onEndReachedThreshold={0.5}
                    pagingEnabled={false}
                    renderItem={({ item, index }) => {
                      const listData = item;
                      return (
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              borderWidth: {
                                minWidth: Breakpoints.Tablet,
                                value: 1,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: Constants['ROW_HEIGHT'],
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['table_values']
                              .props}
                            style={StyleSheet.applyWidth(
                              GlobalStyles.TextStyles(theme)['table_values']
                                .style,
                              dimensions.width
                            )}
                          >
                            {formatAccounting(listData)}
                          </Text>
                        </View>
                      );
                    }}
                    showsHorizontalScrollIndicator={true}
                    showsVerticalScrollIndicator={true}
                    snapToAlignment={'start'}
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Tablet,
                          value: 'stretch',
                        },
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* Cols */}
                <SimpleStyleFlatList
                  data={rothYearsData}
                  decelerationRate={'normal'}
                  inverted={false}
                  keyExtractor={(colsData, index) => index}
                  keyboardShouldPersistTaps={'never'}
                  listKey={'Custom Code->Container->Report->Report->Cols'}
                  nestedScrollEnabled={false}
                  numColumns={1}
                  onEndReachedThreshold={0.5}
                  pagingEnabled={false}
                  renderItem={({ item, index }) => {
                    const colsData = item;
                    return (
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            minWidth: {
                              minWidth: Breakpoints.Tablet,
                              value: 62,
                            },
                            width: { minWidth: Breakpoints.Tablet, value: 62 },
                          },
                          dimensions.width
                        )}
                      >
                        {/* header */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              alignItems: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                              backgroundColor: {
                                minWidth: Breakpoints.Tablet,
                                value: palettes.Brand.Divider,
                              },
                              height: {
                                minWidth: Breakpoints.Tablet,
                                value: 52,
                              },
                              justifyContent: {
                                minWidth: Breakpoints.Tablet,
                                value: 'center',
                              },
                              paddingLeft: {
                                minWidth: Breakpoints.Tablet,
                                value: 5,
                              },
                              paddingRight: {
                                minWidth: Breakpoints.Tablet,
                                value: 5,
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['table_headers']
                              .props}
                            style={StyleSheet.applyWidth(
                              GlobalStyles.TextStyles(theme)['table_headers']
                                .style,
                              dimensions.width
                            )}
                          >
                            {'ROTH\nYear '}
                            {index + 1}
                            {'\nConversion'}
                          </Text>
                        </View>
                        {/* Rows */}
                        <SimpleStyleFlatList
                          data={colsData}
                          decelerationRate={'normal'}
                          horizontal={false}
                          inverted={false}
                          keyExtractor={(rowsData, index) => index}
                          keyboardShouldPersistTaps={'never'}
                          listKey={JSON.stringify(colsData)}
                          nestedScrollEnabled={false}
                          numColumns={1}
                          onEndReachedThreshold={0.5}
                          pagingEnabled={false}
                          renderItem={({ item, index }) => {
                            const rowsData = item;
                            return (
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    borderWidth: {
                                      minWidth: Breakpoints.Tablet,
                                      value: 1,
                                    },
                                    height: {
                                      minWidth: Breakpoints.Tablet,
                                      value: Constants['ROW_HEIGHT'],
                                    },
                                    justifyContent: {
                                      minWidth: Breakpoints.Tablet,
                                      value: 'center',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <>
                                  {!(rowsData > 0) ? null : (
                                    <Text
                                      accessible={true}
                                      selectable={false}
                                      {...GlobalStyles.TextStyles(theme)[
                                        'table_values'
                                      ].props}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.TextStyles(theme)[
                                            'table_values'
                                          ].style,
                                          {
                                            fontSize: {
                                              minWidth: Breakpoints.Tablet,
                                              value: 11,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {formatAccounting(rowsData)}
                                    </Text>
                                  )}
                                </>
                              </View>
                            );
                          }}
                          showsHorizontalScrollIndicator={true}
                          showsVerticalScrollIndicator={true}
                          snapToAlignment={'start'}
                        />
                      </View>
                    );
                  }}
                  snapToAlignment={'start'}
                  horizontal={true}
                  showsHorizontalScrollIndicator={false}
                  showsVerticalScrollIndicator={false}
                />
              </View>
            </Surface>
          </View>
        </View>
      </Utils.CustomCodeErrorBoundary>
    </ScreenContainer>
  );
};

export default withTheme(ReportScreen);
